import DropdownOption from "../components/common/DropdownOption";
import ChartSeries from "./chartSeries";

export class Chart {
  public idChart: number = 0;
  public idProject: number = 0;
  public idUser: number | undefined = undefined;
  public idParentChart: number | undefined = undefined;

  public chartName: string = "";
  public xAxisName: string = "";
  public yAxisName: string = "";

  public isVisible: boolean = false;

  public isShared: boolean = false;
  public isSharedDataChanged: boolean = false;
  public isDefault: boolean = false;

  public useDistanceOnXAxis: boolean = true;
  public xAxisFieldName: string = "";

  public index: number = 0;

  public chartSeries: ChartSeries[] = [];

  public parentChart: Chart | undefined = undefined;

  // used on ui only
  public selectedXAxisFieldOption: DropdownOption<string> | undefined =
    undefined;
}
